module.exports = __webpack_public_path__ + "./docs/img/big-icon-enum.efc3c06a29469b3083fb11e00aed463f.svg";